import React from 'react';
import PropTypes from 'prop-types';
import log from '../lib/log.js';
const logger = log('[wake]');

export default class Wake extends React.PureComponent {
  static propTypes = {
    onWake: PropTypes.func.isRequired,
    interval: PropTypes.number.isRequired,
  };

  componentDidMount() {
    this._last = new Date().getTime();

    this._interval = setInterval(this.check, this.props.interval);
  }

  componentWillUnmount() {
    this._interval && window.clearInterval(this._interval);
  }

  check = () => {
    let current = new Date().getTime();
    if (current - this._last > this.props.interval + 5000) {
      logger.info(
        'waking up after sleep of ' +
          (current - this._last - this.props.interval) / 1000 +
          's'
      );
      this.props.onWake(current - this._last - this.props.interval);
    }
    this._last = current;
  };

  render() {
    return null;
  }
}
